export default {
  name: "Icon"
};